import * as types   from "../../constants/action-types";

let initialState = {
    Translations:{},
    WebMode:'',
    WhoAreWe:{},
    MediaUrl:'',
    About: '',
    Recommendations:{
        config: {
            seconds:1
        },
        data:[]
    },
    PeepsScore:{
        image:{
            path:''
        }
    },
    Date:{
        image:{
            path:''
        }
    },
    EasySearch:{
        image:{
            path:''
        }
    },
    FlowInformation:[],
    LeasingCompanies: [],
    EasyBuy:[],
    FooterItem:[],
    Menu:[],
    CarCategories:[],
    PriceStairs:[],
    SortTypes:[],
    CarBanners:false,
    AboutPage:false,
    HowDoesItWork:false,
    RouteTable:false,
    Faq:false,
    Cities:false,
    Prepay: false,
};

export default function constants_reducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_PREPAY:
            return{
                ...state,
                Prepay: action.payload
            };
        case types.SET_TRANSLATIONS:
            return {
                ...state,
                Translations: action.payload
            };
        case types.SET_WEB_MODE:
            return {
                ...state,
                WebMode: action.payload
            };
        case types.SET_ABOUT:
            return{
                ...state,
                WhoAreWe: action.payload
            };
        case types.SET_MEDIA_URL:
            return{
                ...state,
                MediaUrl: action.payload
            };
        case types.SET_RECOMMENDATIONS:
            return{
                ...state,
                Recommendations: action.payload
            };
        case types.SET_PEEPS_SCORE:
            return{
                ...state,
                PeepsScore: action.payload
            };
        case types.SET_DATE:
            return{
                ...state,
                Date: action.payload
            };
        case types.SET_EASY_SEARCH:
            return{
                ...state,
                EasySearch: action.payload
            };
        case types.SET_FLOW_INFORMATION:
            return{
                ...state,
                FlowInformation: action.payload
            };
        case types.SET_LEASING_COMPANIES:
            return{
                ...state,
                LeasingCompanies: action.payload
            };
        case types.SET_EASY_BUY:
            return{
                ...state,
                EasyBuy: action.payload
            };
        case types.SET_FOOTER_ITEM:
            return{
                ...state,
                FooterItem: action.payload
            };
        case types.SET_MENU:
            return{
                ...state,
                Menu: action.payload
            };
        case types.SET_CAR_CATEGORIES:
            return{
                ...state,
                CarCategories: action.payload
            };
        case types.SET_PRICE_STAIRS:
            return{
                ...state,
                PriceStairs: action.payload
            };
        case types.SET_SORT_TYPES:
            return{
                ...state,
                SortTypes: action.payload
            };
        case types.SET_CAR_BANNERS:
            return{
                ...state,
                CarBanners: action.payload
            };
        case types.SET_ABOUT_PAGE:
            return{
                ...state,
                AboutPage: action.payload
            };
        case types.SET_HOW_DOES_IT_WORK:
            return{
                ...state,
                HowDoesItWork: action.payload
            };
        case types.SET_ROUTES_TABLE:
            return{
                ...state,
                RouteTable: action.payload
            };
        case types.SET_FAQ:
            return{
                ...state,
                Faq: action.payload
            };
        case types.SET_CITIES:
            return{
                ...state,
                Cities: action.payload,
            };
        default:
            return state;
    }
}
